// extracted by mini-css-extract-plugin
module.exports = {"qrCodeContainer":"qr-code_qrCodeContainer__2dMIR"};